import { handleActions } from 'redux-actions'

const initialState = {
  featured: [],
  loading: false,
  error: null,
}

const learnGuides = handleActions({
  GET_LEARN_GUIDES_FEATURED_PENDING(state) {
    return Object.assign({}, state, { loading: true, error: null })
  },

  GET_LEARN_GUIDES_FEATURED_FULFILLED(state, { payload }) {
    return Object.assign({}, state, {
      featured: payload,
      loading: false,
      error: null
    })
  },

  GET_LEARN_GUIDES_FEATURED_REJECTED(state, { payload }) {
    return Object.assign({}, state, {
      loading: false,
      error: payload
    })
  },
}, initialState)

export default learnGuides

const LearnGuidesSelectors = {
  getFeaturedGuides(state) {
    return state.learnGuides.featured
  },

  isLoading(state) {
    return state.learnGuides.loading
  },
}

export { LearnGuidesSelectors }
